import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  lookupSubscriptions,
  registerSubscription,
  cancelActiveSubscription,
  getCustomerInfo,
  getAvailableProducts,
  validateOrder,
  registerProduct,
  getRegisteredProducts,
  updateRegisteredProductStatus,
  deleteCustomerCache,
} from '../services/SubscriptionsService';

export const useSubscriptionsLookupSubscriptions = createDCHook(
  'lookupSubscriptions',
  collapseDataFromCall(lookupSubscriptions),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useSubscriptionsRegisterSubscription = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(registerSubscription, 'requestBody', 'data'),
      'data',
      'tier',
      'consentVersion',
      'type',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['tier', 'consentVersion', 'type'] },
    ],
  },
);

export const useSubscriptionsCancelActiveSubscription = createMutationHook(cancelActiveSubscription, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useSubscriptionsGetCustomerInfo = createDCHook('getCustomerInfo', collapseDataFromCall(getCustomerInfo), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useSubscriptionsGetAvailableProducts = createMutationHook(collapseDataFromCall(getAvailableProducts), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useSubscriptionsValidateOrder = createMutationHook(collapseDataFromCall(validateOrder), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useSubscriptionsRegisterProduct = createMutationHook(collapseDataFromCall(registerProduct), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useSubscriptionsGetRegisteredProducts = createDCHook(
  'getRegisteredProducts',
  collapseDataFromCall(getRegisteredProducts),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useSubscriptionsUpdateRegisteredProductStatus = createMutationHook(updateRegisteredProductStatus, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useSubscriptionsDeleteCustomerCache = createMutationHook(deleteCustomerCache, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});
